import React from 'react'
import { Button } from '@shared/components/button'
import { scrollToApplicationForm } from '@shared/components/forms/application/cross'
import ArrowRight from '@shared/svg/arrow-right.svg'

import styles from './style.module.scss'

interface Props {
	points?: string[]
	buttonText?: string
}

const ratePointsData = [
	'Без подтверждения дохода',
	'Одобрение за 30 минут',
	'Никаких брокерских комиссий',
	'Без поручителей',
	'Все расходы по сделке — на нас',
]

const RatePoint = ({ text }: { text: string }) => (
	<div className={styles.ratePoint}>
		<div className={styles.rateIcon}>
			<ArrowRight />
		</div>
		<p>{text}</p>
	</div>
)

export const View = ({ points, buttonText = 'Получить кредит сейчас' }: Props) => (
	<div className={styles.rateWrapper}>
		<div className={styles.ratePercentBackground}>%</div>
		<div className={styles.rateContent}>
			<div className={styles.left}>
				<h2>Вам доступны лучшие условия</h2>
				<Button size='l' className={styles.buttonLeft} onClick={scrollToApplicationForm}>
					{buttonText}
				</Button>
			</div>
			<div className={styles.ratePoints}>
				{(points || ratePointsData).map((text) => (
					<RatePoint key={text} text={text} />
				))}
			</div>
			<Button size='l' className={styles.button} onClick={scrollToApplicationForm}>
				{buttonText}
			</Button>
		</div>
	</div>
)
